import { render } from "./Trigger.vue?vue&type=template&id=0882a8e6&scoped=true"
import script from "./Trigger.vue?vue&type=script&lang=js"
export * from "./Trigger.vue?vue&type=script&lang=js"

import "./Trigger.vue?vue&type=style&index=0&id=0882a8e6&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0882a8e6"]])

export default __exports__